import React, {useEffect} from "react";
import { Select, Spin } from 'antd';
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import {OrderNote} from "../OrderNote";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../../../../store/selector";
import {fetchGetTotalResultAction} from "../../../../../../store/pages/admission/actions";
import {useSearchParams} from "react-router-dom";
import {decodeBase64} from "../../../../../../utils/decodeBase64";

const {Option} = Select;

export const ExecutorStepSix = ({
                   fio_entrant,
                   order,
                   groupList,

                   edit,

                   subAdminsHandler,
                   dateHandler,
                   numberHandler,
                   basisRuHandler,
                   basisKzHandler,
                   groupHandler,
                   disableAll,
                   disable,
                   type,
                   title
                 }:any) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps'])

  const education_order_id = decodeBase64(searchParams.get("education_order_id"));

  const {admission: {getTotalResult}} = useSelector(selectStore)

  useEffect(() => {
    if(!getTotalResult.success){
      // @ts-ignore
      dispatch(fetchGetTotalResultAction({education_order_id}))
    }
  }, [getTotalResult.success]);

  return (
    groupList ?
      <>
        <div className="admission__content-item">
          {title && <h3 className="admission__subtitle">{title}</h3>}

          <p
            style={{marginBottom: 0, fontSize: "12px"}}
          >{t('admissionView:group')}</p>
          <Select
            value={order.group_id && order.group_id}
            style={{width: "100%"}}
            onChange={(value, option) => groupHandler(value, option)}
            placeholder={t('admissionView:stepsTitle.stepSix.caption.select')}
            disabled={disable || disableAll}
          >
            {groupList && groupList?.groupsReception.map((item:any) => (
              <Option key={item.caption} value={item.id} caption_kk={item.caption_kk}>{item.caption}</Option>
            ))}
          </Select>

          <div style={{display: "flex", alignItems: "center", margin: "10px 0"}}>
            {type &&
                <>
                    <InfoCircleOutlined style={{color: "#51258F", marginRight: 10}}/>
                    <p style={{margin: 0}}>{`${type === "admission" ? (!order.group ? t('admissionView:stepsTitle.stepSix.caption.addToGroup') : t('admissionView:stepsTitle.stepSix.caption.addToGroup2')) : '' }`}</p>
                </>
            }
          </div>

          {(order.group || order.group_id || edit) &&
              <>
                  <OrderNote
                      lang="ru"
                      warningText
                      disableAll={disableAll}
                      disable={disable}
                      admins={groupList && groupList.reception.teachers}
                      order={order}

                      fio_entrant={fio_entrant}
                      admin={groupList && groupList.reception.director && groupList.reception.director.fio}

                      dateHandler={dateHandler}
                      subAdminsHandler={subAdminsHandler}
                      numberHandler={numberHandler}
                      basisRuHandler={basisRuHandler}
                      basisKzHandler={basisKzHandler}
                  />

                  <OrderNote
                      lang="kz"
                      warningText
                      disableAll={disableAll}
                      disable={disable}
                      admins={groupList && groupList.reception.teachers}
                      order={order}

                      fio_entrant={fio_entrant}
                      admin={groupList && groupList.reception.director && groupList.reception.director.fio}

                      dateHandler={dateHandler}
                      subAdminsHandler={subAdminsHandler}
                      numberHandler={numberHandler}
                      basisRuHandler={basisRuHandler}
                      basisKzHandler={basisKzHandler}
                  />
              </>
          }
        </div>
      </>

      :
      <Spin style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
      }}/>
  )
}